import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/shared/store/store';

const selectPermissionsState = (state: RootState) => state.rbacPermissions;

export const selectPermissions = createSelector(
  [selectPermissionsState],
  (state) => (state?.permissions && Array.isArray(state.permissions)) ? state.permissions : []
);

export const selectSelectedPermissions = createSelector(
  [selectPermissionsState],
  (state) => (state?.selectedPermissions && Array.isArray(state.selectedPermissions)) ? state.selectedPermissions : []
);

export const selectPermissionsLoading = createSelector(
  [selectPermissionsState],
  (state) => state.loading
);

export const selectPermissionsError = createSelector(
  [selectPermissionsState],
  (state) => state.error
);

